import type { RouteRecordRaw } from 'vue-router'
import type { RouterType } from '@/types/router'

import { createRouter, createWebHistory, RouteRecordName } from 'vue-router'
import { jurisdictionRouter } from '@/utils/menu'
import { cloneDeep } from '@/utils'
import Layout from '@/views/layout/index.vue'
import { noMenuRoute } from './noMenu'
import { myAccountRoute } from './myAccount'
import { footerRoute } from './footer'
import store from '@/store'

// const originalPush = VueRouter.prototype.push

// VueRouter.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch((err) => err)
// }

// 基础路径
export const baseRoutes: RouterType[] = [
  {
    path: '/',
    redirect: '/about',
    name: 'layout',
    component: Layout
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/404',
    component: () => import('@/views/base/404.vue')
  }
]

const routes = [...baseRoutes, ...noMenuRoute, ...footerRoute]

const router = createRouter({
  history: createWebHistory(),
  routes: routes as RouterType[] as RouteRecordRaw[]
})

// 登录后获取角色下的权限路由信息
export const loginRouter = () => {
  // 需要进行权限验证的路由信息
  const perRouteModule = [myAccountRoute, noMenuRoute].map((router) => cloneDeep(router))

  const { routerMenuList } = jurisdictionRouter(perRouteModule)

  const roleRouter = routerMenuList
  roleRouter.push({
    path: '/:catchAll(.*)',
    redirect: '/404'
  })

  return roleRouter
}

/**
 * 初始化路由表
 */
export function resetRouter() {
  if (store.getters['moduleCommon/getPermissionRouter']) {
    const menus = store.getters['moduleCommon/getPermissionRouter']
    menus.forEach((menu: any) => {
      router.removeRoute(menu)
    })
  }
}

/**
 * 获取所有模块的路由数据
 */
export const getAllModuleRouter = () => {
  // 目前模块： 我的账户
  return [myAccountRoute].map((router) => cloneDeep(router))
}

export default router
